import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import { modals, showNotificationModal } from '../state/modules/messaging';
import { AppStoreState } from 'types';

class SWNotifier extends Component<any> {
  handleContentUpdate = () => {
    this.props.showNotificationModal(modals.notifications.refreshModal);
  };

  componentDidMount() {
    document.addEventListener('updateDetected', this.handleContentUpdate);
  }

  componentWillUnmount() {
    document.removeEventListener('updateDetected', this.handleContentUpdate);
  }

  render() {
    return (
      <div
        style={{
          width: '100%',
          height: '100%'
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state: AppStoreState) => ({
  messaging: state.messaging
});

export default connect(mapStateToProps, {
  showNotificationModal
})(SWNotifier as any);
